import { useState } from "react";
import PageContainer from "../../Component/Common/Page";
import PageHeader from "../../Component/Common/PageHeader";
import MultiButton from "../../Component/extra/MultiButton";
import ManageVideo from "./ManageVideo";
import dayjs from "dayjs";
import NewVideoAdd from "../../Component/dialogue/NewVideoAdd";
import { useSelector } from "react-redux";
import VideoComments from "./VideoComments";

export default function VideoPage() {
  const [multiButtonSelect, setMultiButtonSelect] = useState("Manage Video");
  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");
  const { tokenData } = useSelector((state) => state.loggedUser);
  const { orgProfile } = useSelector((state) => state.organization);
  const { dialogueType } = useSelector((state) => state.dialogue);

  const startDateFormat = (startDate) => {
    return startDate && dayjs(startDate).isValid()
      ? dayjs(startDate).format("YYYY-MM-DD")
      : "All";
  };
  const endDateFormat = (endDate) => {
    return endDate && dayjs(endDate).isValid()
      ? dayjs(endDate).format("YYYY-MM-DD")
      : "All";
  };

  const startDateData = startDateFormat(startDate);
  const endDateData = endDateFormat(endDate);

  return (
    <PageContainer className="userPage videoPage">
      <div
        style={{
          display: `${dialogueType === "editVideo" ? "none" : "block"}`,
        }}
      >
        <PageHeader
          heading={tokenData?.isOrg ? "" : "Welcome Admin"}
          subHeading={tokenData?.isOrg ? "" : "Video"}
          showDateRange={true}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />

        <MultiButton
          label={
            tokenData?.isOrg
              ? ["Manage Video", "Import Videos"]
              : ["Manage Video", "Manage Video Comments", "Import Videos"]
          }
          multiButtonSelect={multiButtonSelect}
          setMultiButtonSelect={setMultiButtonSelect}
        />

        {multiButtonSelect == "Manage Video" && (
          <ManageVideo endDate={endDateData} startDate={startDateData} />
        )}
        {multiButtonSelect == "Manage Video Comments" && (
          <VideoComments endDate={endDateData} startDate={startDateData} />
        )}
        {multiButtonSelect == "Import Videos" && (
          <NewVideoAdd setMultiButtonSelect={setMultiButtonSelect} />
        )}
      </div>
      {dialogueType === "editVideo" && <NewVideoAdd />}
    </PageContainer>
  );
}
